import React from "react";
import { Pencil, Trash2 } from "lucide-react";
import DataTable from "../../common/components/DataTable";
import PrimaryButton from "../../common/components/PrimaryButton";
import DeleteModal from "../../common/components/DeleteModal";
import SubscriberForm from "./SubscriberForm";
import UploadForm from "./UploadForm";

function Subscribers({
  action,
  setAction,
  subscribers,
  refetch,
  isOwner,
  onDelete,
  isDeleting,
  onClose,
}) {
  const { subscriberId, email } = action?.data || {};

  let defaultcolumn = true;

  const columns = [{ key: "email", header: "Email" }];

  const actions = [
    {
      icon: <Pencil size={20} color={"blue"} />,
      onClick: (row) => {
        setAction({
          type: "Edit",
          isOpen: true,
          data: { subscriberId: row._id, email: row.email },
        });
      },
      color: "blue",
    },
    {
      icon: <Trash2 size={20} color={"red"} />,
      onClick: (row) => {
        setAction({
          type: "Delete",
          isOpen: true,
          data: { subscriberId: row._id, email: row.email },
        });
      },
      color: "red",
    },
  ];

  return (
    <div className="text-gray-700">
      <div className="flex justify-between items-center mb-8">
        <div className="text-2xl font-bold">Subscribers</div>
        {isOwner && (
          <div className="flex gap-4">
            <button
              btnCls="!w-fit"
              className="rounded-md  fileButton text-white px-4 py-2 nav_link-500 transition ease-in-out duration-300"
              onClick={() => setAction({ type: "Upload", isOpen: true })}
            >
              Upload Subscribers
            </button>
            <PrimaryButton
              btnCls="!w-fit"
              buttonProps={{
                onClick: () => setAction({ type: "Add", isOpen: true }),
              }}
            >
              + Add Subscriber
            </PrimaryButton>
          </div>
        )}
      </div>
      <div>
        <DataTable
          data={subscribers}
          defaultcolumn={defaultcolumn}
          columns={columns}
          actions={actions}
        />
      </div>

      <SubscriberForm
        title={`${action.type} Subscriber`}
        open={["Add", "Edit"].includes(action.type) && action.isOpen}
        setOpen={onClose}
        onSuccess={refetch}
        subscriberId={subscriberId}
        email={email}
      />

      <UploadForm
        title="Upload Subscribers"
        open={action.type === "Upload" && action.isOpen}
        setOpen={onClose}
        onSuccess={refetch}
        onClick={() => setAction({ type: "Upload", isOpen: false })}
      />

      <DeleteModal
        title={`Are you sure, you want to delete this subscriber (${email})?`}
        open={action.type === "Delete"}
        setOpen={onClose}
        onDelete={() => onDelete(subscriberId)}
        isDeleting={isDeleting}
      />
    </div>
  );
}

export default Subscribers;
